import { useEffect, useMemo } from "react";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import PropTypes from "prop-types";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import SendBackPainButton from "./Table/SendBackPainButton";
import Button from "@material-ui/core/Button";

const SendBackOrdersComponent = ({
  sendBacks,
  fetchSendBackOrders,
  confirmSendBackOrder,
  ...props
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(getColumns, []);

  useEffect(() => {
    fetchSendBackOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="deposit-layout body-height">
      <RefreshButton onRefreshClick={fetchSendBackOrders} />
      <h3>Pending sendback orders</h3>
      {sendBacks.fetched ? (
        <TableNew
          {...props}
          selectId={"Id"}
          columns={columns}
          items={sendBacks.data.filter((item) => {
            return !item.Executed;
          })}
          actionColumnWidth={200}
          order="-OrderDate"
          tableKey="send_back_orders"
          aboveContentRenderer={(getSelected, rows, props) => {
            return (
              <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
                <SendBackPainButton
                  {...props}
                  getSelected={getSelected}
                  rows={rows}
                />
              </ClaimsWrapper>
            );
          }}
        />
      ) : (
        <div>Fetching data...</div>
      )}
    </div>
  );

  function getColumns() {
    return [
      {
        key: "InvestorId",
        label: "Investor Id",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      { key: "Id", label: "Order Id", visible: true },
      { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.money },
      { key: "Currency", label: "Currency", visible: true },
      { key: "Order Notes", label: "Notes", visible: true },
      { key: "BankAccountNumber", label: "Bank account", visible: true },
      { key: "BankName", label: "Bank", visible: true },
      { key: "BankAccountHolderName", label: "Holder Name", visible: true },
      {
        key: "AmlWarning",
        label: "Aml Warning Trigger",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <div>{value?.Trigger}</div>;
        },
      },
      {
        key: "AmlWarning",
        label: "Aml Note",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return (
            <div>
              {value?.Notes &&
                value.Notes.sort((a, b) => {
                  return new Date(b.Created) - new Date(a.Created);
                })[0]?.Note}
            </div>
          );
        },
      },
      {
        key: "Id",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value) => {
          return (
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <div className="table-cell-actions">
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "2px" }}
                  onClick={() => confirmSendBackOrder(value)}
                >
                  Confirm
                </Button>
              </div>
            </ClaimsWrapper>
          );
        },
      },
    ];
  }
};

SendBackOrdersComponent.propTypes = {
  accountId: PropTypes.string,
  currentUser: PropTypes.object,
  sendBacks: PropTypes.object,
  fetchSendBackOrders: PropTypes.func,
  confirmSendBackOrder: PropTypes.func,
};

export default SendBackOrdersComponent;
